export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '3857253', dateTime: 1775242821533 };